import { useScale } from "common/utils";
import { MainTitleTag } from "features/courses/assets";
import { ProgramProgress, CourseMessageContent } from "features/courses/types";
import { Level } from "./Level";
import { LevelAnimation } from "./LevelAnimation";
import { StageLevelRects } from "./StageLevelRects";

export const Levels = ({
  scale,
  stage,
  display,
  progresses,
  handleLevelPress,
}: {
  scale: number;
  stage: number;
  display: CourseMessageContent;
  progresses: ProgramProgress;
  handleLevelPress: (stepId: number) => void;
}) => {
  const { width } = useScale();

  const TITLE_HEIGHT = 166;
  const LEVEL_RECT_CIRCLE_RADIUS = 96;
  const LEVEL_RECT_CIRCLE_STROKE = 20;

  const LEVEL_RECT_LEFTS = StageLevelRects[stage - 1].map((r) => r.left);
  const MIN_LEFT =
    Math.min(...LEVEL_RECT_LEFTS) -
    (282 / 2 - LEVEL_RECT_CIRCLE_RADIUS - LEVEL_RECT_CIRCLE_STROKE / 2);

  const MAX_LEFT =
    Math.max(...LEVEL_RECT_LEFTS) +
    282 / 2 +
    LEVEL_RECT_CIRCLE_RADIUS +
    LEVEL_RECT_CIRCLE_STROKE / 2;

  const offsetX =
    (width - (MAX_LEFT - MIN_LEFT) * scale) / 2 - MIN_LEFT * scale + 20 * scale;

  return (
    <>
      <div
        className="flex-row-center self-center"
        style={{
          width: 1000 * scale,
          height: TITLE_HEIGHT * scale,
        }}
      >
        <div
          className="flex-row-center"
          style={{
            width: 364 * scale,
            height: TITLE_HEIGHT * scale,
          }}
        >
          <div
            className="flex-col-view w-[364px] h-[166px] z-[10]"
            style={{
              transform: `scale(${scale})`,
            }}
          >
            <MainTitleTag />
            <p className="title-text !text-[60px] text-textcolor-black !absolute top-[20%] left-[15%] rotate-[-10deg]">
              {display?.name}
            </p>
          </div>
        </div>
      </div>

      <div className="flex-col-el flex-1 flex-center w-full h-full">
        <div className="flex-col-view w-full" style={{ height: 800 * scale }}>
          {progresses.level.map((_, index) => (
            <Level
              key={index}
              stage={stage}
              offset={offsetX}
              scale={scale}
              radius={LEVEL_RECT_CIRCLE_RADIUS}
              step={index}
              display={display}
              progresses={progresses}
              handleLevelPress={handleLevelPress}
            />
          ))}
          <LevelAnimation
            offset={offsetX}
            scale={scale}
            stroke={LEVEL_RECT_CIRCLE_STROKE}
            radius={LEVEL_RECT_CIRCLE_RADIUS}
            stage={stage}
            progresses={progresses}
          />
        </div>
      </div>
    </>
  );
};
